import React from 'react';
import NotificationTemplate from "./NotificationTemplate";
import history from '../../../history';

function NewOperatorRequestTemplate({ request , onClick }) {

    return <NotificationTemplate title={"New Operator Registration"}
                                 onClick={() => {

                                     history.push('/operators');

                                     if(onClick){
                                         onClick();
                                     }

                                 }}
                                 properties={[
                                     {
                                         title: "Full Name",
                                         value: request.name
                                     },
                                     {
                                         title: "Phone No.",
                                         value: request.phone
                                     },
                                     {
                                         title: "Location",
                                         value: request.location
                                     }
                                 ]}>

    </NotificationTemplate>

}

export default NewOperatorRequestTemplate;


// WEBPACK FOOTER //
// ./src/common/UserNotifications/PopupTemplates/NewOperatorRequestTemplate.js